import styled from 'styled-components';

const StyledApp= styled.div`

  margin: 30px 0 60px 0;

  h1 {
  	padding-left: 15px;
  	cursor: pointer;
  	a {
  		color: #333;
  	}
  	a:hover {
			text-decoration:none;
		}
  }

	.af-scroll {
		position: relative;
		border-top: 1px dashed #000;
		border-bottom: 1px dashed #000;

	}
	.af-scroll-debug {
		border-top: 1px dashed #f00;
    position: absolute;
    top: ${props => props.slideHeight/2}px;
    width: 100%;
    z-index: 2;
    display: none;
	}
	#af-scroll-text {
		position: relative;
		padding: 0;
		height: ${props => props.slideHeight}px;
		overflow: auto;
		-webkit-overflow-scrolling: touch;
	}
	.af-step {
		margin: 0;
		padding: 21px 21px 0 0;
		width: 50%;

		p {
			margin: 0;
			padding: 3px 15px;
			font-size: 18px;
		}

		h4 {
			font-size: 21px;
			padding: 0 15px 0 15px;
		}

		ol, ul {
			padding-left: 36px;
		}
		ul {
			list-style: square;
		}

		li {
			color: #333;
			font-size: 18px;
			padding: 0 5px 5px 5px;
		}

		a.internal {
			color: #333;
			border-bottom: 1px dashed #333;
			text-decoration: none;
		}

		.toolTipParent {
			border-bottom: 1px dashed #333;
			cursor: default;
		}
		.toolTipParent:hover {
			background-color: #e5b2cf;
		}


	}

	#af-step-1 {
		p {
			font-size: 20px;
			//font-weight: bold;
		}
	}

	.af-step:nth-child(even){
		background-color: #fff;
	}

	.af-step:last-of-type {
		p:last-of-type {
			padding-bottom:45px;
		}
	}

	.af-arrow-buttons {
		position: absolute;
		width: 50%;
		bottom: 0;
		height: 30px;
		background-color: #fff;
		opacity: 0.8;
	}

	.af-arrow-up,
	.af-arrow-down {
		position: absolute;
		border: none;
		background: none;
		bottom: 12px;
		svg {
			width: 30px;
			height: 15px;
		}
	}

	.af-arrow-up {
		right: 15px;
	}

	.af-arrow-down {
		left: 15px;
	}


  @media (max-width: 576px) {
  	.af-step {
  		width: 100%;
  	}
  	.af-scroll-debug {
  		top: 550px;
  		border-top: 1px dashed #a90060;
  	}
  }


`;

export default StyledApp;



// WEBPACK FOOTER //
// ./src/components/App/StyledApp.js